import { useLocation } from 'react-router-dom';
import { carePortalPages } from '../pages';

type AppLocation = 'admin-dashboard' | 'avon-patient' | 'care-portal';

/**
 * Maps the URL to a coarse app shell bucket (admin vs Avon embed vs care portal chrome).
 * Side effects: none — reads router location only.
 */
export const useAppLocation = (): AppLocation => {
  const location = useLocation();
  const pathname = location.pathname;

  if (pathname.includes('admin-dashboard')) {
    return 'admin-dashboard';
  }

  if (pathname.includes('avon-patient')) {
    return 'avon-patient';
  }

  // TV wall board: public route (no session chrome); bucket as care-portal for shell helpers.
  if (pathname.includes('tv-dashboard')) {
    return 'care-portal';
  }

  if (
    pathname === '/' ||
    carePortalPages.some(page => pathname.includes(page))
  ) {
    return 'care-portal';
  }

  throw new Error('Unknown app location');
};
